<template lang="html">
    <div class="table-wrap groundwater-quality-table">
        <scrolling-table v-if="tableData" class="scroll-table" :data="tableData" />
        <div class="loading" v-if="!tableData">
            <p>Loading...</p>
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
    </div>
</template>

<script>
import gql from 'graphql-tag';
import ScrollingTable from '@/components/ScrollingTable';

export default {
    components: {
        ScrollingTable,
    },
    computed: {
        stationId() {
            const station = this.$store.state.map.selectedStation;
            if (!station) {
                return null;
            }
            return station.id;
        },
    },
    apollo: {
        tableData: {
            query: gql`query stationChemTable($id: Int!) {
                getStation(id: $id) {
                    chemistry {
                        table
                    }
                }
            }`,
            variables() {
                return {
                    id: this.stationId,
                };
            },
            update(data) {
                const formatted = data.getStation.chemistry.table;
                return formatted;
            },
        },
    },
};
</script>

<style lang="scss">
.groundwater-quality-table.table-wrap {
    overflow: auto;

    .scroll-table {
        height: calc(100vh - 220px);
    }

    .loading {
        height: 16rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/GroundwaterQualityTable.vue